import {CoworkHomeComponent} from './coworkhome/components';
// Styles
import '../assets/sass/web/_coworkhome.scss';
import {adServicesInit} from './services/adServices'

require('./controller/header.js')

// Since it is a page component, initialize it
const page = new CoworkHomeComponent(document.body);
$(window).on('load', function () {
        adServicesInit()
});
